export let KnowledgeBaseListenerEvent = /*#__PURE__*/function (KnowledgeBaseListenerEvent) {
  /**
   * Invoked when a resource is opened.
   */
  KnowledgeBaseListenerEvent["RESOURCE_OPENED"] = "EVENT_RESOURCE_OPENED";
  /**
   * Invoked when a resource is closed.
   */
  KnowledgeBaseListenerEvent["RESOURCE_CLOSED"] = "EVENT_RESOURCE_CLOSED";
  /**
   * Invoked when a resource is liked.
   */
  KnowledgeBaseListenerEvent["RESOURCE_LIKED"] = "EVENT_RESOURCE_LIKED";
  /**
   * Invoked when a resource is disliked.
   */
  KnowledgeBaseListenerEvent["RESOURCE_DISLIKED"] = "EVENT_RESOURCE_DISLIKED";
  return KnowledgeBaseListenerEvent;
}({});
//# sourceMappingURL=Listener.js.map